import { isValidEmailAddress, isValidPassword, elementInViewport } from '../functions';


$(document).ready(function() {

	$(document).on('click', '.apply-filter-btn', function(e) {
		e.preventDefault();
		let url = $(this).data('url');

		var filters = '';

		let vehicleClassses = [];
		$('input[name="vehicle-class"]:checked').each(function() {
			vehicleClassses.push($(this).val());
		});
		if (vehicleClassses.length > 0) {
			filters = filters + '&vc=' + vehicleClassses.join(',');
		}

		let transmissions = [];
		$('input[name="transmission"]:checked').each(function() {
			transmissions.push($(this).val());
		});
		if (transmissions.length > 0) {
			filters = filters + '&t=' + transmissions.join(',');
		}

		let passengers = [];
		$('input[name="passengers"]:checked').each(function() {
			passengers.push($(this).val());
		});
		if (passengers.length > 0) {
			filters = filters + '&p=' + passengers.join(',');
		}

		window.location = url + filters;
	});

	$(document).on('click', '.mobile-apply-filter-btn', function(e) {
		e.preventDefault();
		let url = $(this).data('url');

		var filters = '';

		let vehicleClassses = [];
		$('input[name="mobile-vehicle-class"]:checked').each(function() {
			vehicleClassses.push($(this).val());
		});
		if (vehicleClassses.length > 0) {
			filters = filters + '&vc=' + vehicleClassses.join(',');
		}

		let transmissions = [];
		$('input[name="mobile-transmission"]:checked').each(function() {
			transmissions.push($(this).val());
		});
		if (transmissions.length > 0) {
			filters = filters + '&t=' + transmissions.join(',');
		}

		let passengers = [];
		$('input[name="mobile-passengers"]:checked').each(function() {
			passengers.push($(this).val());
		});
		if (passengers.length > 0) {
			filters = filters + '&p=' + passengers.join(',');
		}

		window.location = url + filters;
	});

	$(document).on('click', '.button_rezerva_form', function(e) {
		e.preventDefault();
		let url = $(this).data('url');
		let queryString = $(this).data('query-string');
		let group = $(this).data('group');
		let insurance = $(this).data('insurance');

		window.location = url + '?' + queryString + '&group=' + group + (insurance != '' ? '&insurance=' + insurance : '');
	});

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/groups.js